<template>
    <div class="mt-5 vld-parent" align="center">
        <loading :active.sync="isLoading" background-color="transparent" :is-full-page="false"/>
        <div align="center"><img src="../assets/img/logo.gif" alt="" width="174" height="35" border="0"></div>
        <br/>
        <div v-if="errMessage.length > 0" class="font-weight-bold text-danger mt-2 mb-2">{{errMessage}}</div>
        <div id="content">
            <div id="formLogin">
                <h2>{{$t('login.labels.title')}}</h2>
                <div>
                    <div class="form-group">
                      <input v-model="formObj.compCd" ref="compCd" type="text" maxlength="16" class="form-control" :placeholder="$t('login.labels.compCd')">
                      <small v-if="isError('compCd')" class="form-text text-left text-danger pl-1">* {{$t('login.labels.compCdEmptyErr')}}</small>
                    </div>
                    <div class="form-group">
                      <input v-model="formObj.userCd" ref="userCd" type="text" maxlength="10" class="form-control" :placeholder="$t('login.labels.userCd')">
                      <small v-if="isError('userCd')" class="form-text text-left text-danger pl-1">* {{$t('login.labels.userCdEmptyErr')}}</small>
                    </div>
                    <div class="form-group">
                      <input v-model="formObj.password" ref="password" type="password" maxlength="256" v-on:keydown.enter.prevent="submit" class="form-control no-enter-as-tab" :placeholder="$t('login.labels.password')">
                      <small v-if="isError('password')" class="form-text text-left text-danger pl-1">* {{$t('login.labels.passwordEmptyErr')}}</small>
                    </div>
                    <button v-on:click="submit" class="btn btn-danger btn-block no-enter-as-tab" :disabled="isLoading">
                      <!-- <span v-if="isLoading" class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span> -->
                      {{$t('login.buttons.login')}}
                    </button>
                </div>
            </div>
            <div id="cta">{{$t('login.labels.description')}}</div>
        </div>
    </div>
</template>

<script>
import EventBus from "../assets/js/eventBus";
import axios from "assets/js/request";
import Loading from 'vue-loading-overlay';

export default {
  name: "Login",
  components: {
    Loading
  },
  data: function() {
    return {
      formObj: {},
      errMessage: "",
      errIds: [],
      localValidate: false,
      isLoading: false
    };
  },
  mounted: function() {
    this.$refs.compCd.focus();
  },
  methods: {
    submit: function() {
      var _this = this;
      var i = 0;
      for (i = 0; i < this.errIds.length; i++) {
        this.$refs[this.errIds[i]].classList.remove('border-red');
      }
      if (this.validate()) {
        _this.isLoading = true;
        axios
          .post(_this.$UrlConstants.AUTH + _this.$UrlConstants.LOGIN, _this.formObj)
          .then(function(response) {
            sessionStorage.compNm = response.data.compNm + " " + response.data.userName;
            sessionStorage['leftMenu'] = JSON.stringify(response.data.leftMenu);
            sessionStorage['accessedScreens'] = JSON.stringify(response.data.accessedScreens);
            sessionStorage.template = response.data.templateId;
            sessionStorage.authorization = response.headers.authorization;
            EventBus.$emit("login");
          })
          .catch(function(error) {
            console.log(error.response);
            _this.isLoading = false;
            setTimeout(function() {_this.$refs.compCd.focus();}, 0);
            if (error.response == undefined) {
              _this.errMessage = _this.$t('login.labels.errUndefined');
            } else {
              var data = error.response.data;
              if (data != undefined && data.message != undefined) {
                _this.errMessage = data.message;
                if (data.id != undefined && data.id != '') {
                  _this.errIds.push(data.id)
                  _this.$refs[data.id].classList.add('border-red');
                  _this.$refs[data.id].focus();
                }
              } else {
                _this.errMessage = "Error: " + error.response.status;
              }
            }
        });
      } else {
        _this.$refs[_this.errIds[0]].focus();
        for (i = 0; i < _this.errIds.length; i++) {
          _this.$refs[_this.errIds[i]].classList.add('border-red');
        }
      }
    },
    validate: function() {
      if (!this.localValidate) return true;
      this.errIds = [];
      var formObj = this.formObj;
      console.log(this.formObj);
      if (formObj.compCd == undefined || formObj.compCd == '') {
        this.errIds.push('compCd');
      }
      if (formObj.userCd == undefined || formObj.userCd == '') {
        this.errIds.push('userCd');
      }
      if (formObj.password == undefined || formObj.password == '') {
        this.errIds.push('password');
      }
      return this.errIds.length == 0;
    },
    isError: function(name) {
      if (!this.localValidate) return false;
      return this.errIds.includes(name);
    }
  }
};
</script>

<style scoped>
#content {
  max-width: 320px;
  position: relative;
  background: #ffffff;
  border-top: 5px solid #cc0000;
  box-shadow: 0 0 20px rgba(100, 100, 100, 0.5);
  margin: 0 auto;
}
#formLogin {
  padding: 40px;
}
h2 {
  margin: 0 0 20px;
  color: #cc0000;
  font-size: 18px;
  font-weight: bold;
  line-height: 1;
}
#cta {
  background: #e9e9e9;
  padding: 15px 25px;
  box-sizing: border-box;
  color: #666666;
  font-size: 12px;
  line-height: 18px;
}
.border-red {
  border-color: red;
}
</style>
